import React, { MouseEventHandler } from 'react'
import { StopGenerationIcon } from '../types'
import { Icon } from '@contentstack/venus-components'
import StopIcon from "../assets/StopButton"
import './StopGenerationButton.css'

interface IStopGenerationButton {
  handleStopGeneration: MouseEventHandler<HTMLDivElement>
  icon: StopGenerationIcon
}

export default function StopGenerationButton({ handleStopGeneration, icon }: IStopGenerationButton) {
  return (
    <div className='stop-generator' onClick={handleStopGeneration}>
      <span>
        {
          icon === 'square' ? <StopIcon /> : (
            <Icon
              data-test-id="ai-asst-submit-btn-primary-action-brainstrom-stop"
              version="v2"
              icon={'Cancel'}
              size="small"
              fill='#6C5CE7'
              stroke='#6C5CE7'
            />
          )
        }</span>
      <span className={`stop-text ${icon === "cancel" ? "stop-gen-cancel" : ""}`}>
        Stop Generating
      </span>
    </div>
  )
}
